(function () {
  'use strict';

  /* @ngdoc object
   * @name bmfexport
   * @description
   *
   */
  angular
    .module('finance.bmfexport', [
      'ui.router',
      'ui.bootstrap'
    ]);
}());
